export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20reader%20with%20warm%20smile%2C%20simple%20orange%20gradient%20background%2C%20flat%20illustration%20style%2C%20minimalist%20design&width=120&height=120&seq=avatar-cmt-01&orientation=squarish',
    name: '追漫小达人',
    time: '2小时前',
    content: '汗汗漫画真的太良心了！全集免费看，画质还这么清晰，追了三年了一直没换过平台。',
    likes: 326,
    manga: '《斗罗大陆》',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20with%20glasses%20and%20gentle%20smile%2C%20warm%20amber%20gradient%20background%2C%20clean%20minimalist%20illustration&width=120&height=120&seq=avatar-cmt-02&orientation=squarish',
    name: '漫画收藏家',
    time: '5小时前',
    content: '资源太全了！日漫国漫都有，更新速度也快，每天午休必刷，已经推荐给身边所有漫友了。',
    likes: 218,
    manga: '《完美世界》',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20male%20avatar%20with%20headphones%2C%20warm%20coral%20gradient%20background%2C%20modern%20flat%20illustration%20design&width=120&height=120&seq=avatar-cmt-03&orientation=squarish',
    name: '夜半追更人',
    time: '8小时前',
    content: '自从发现汗汗漫画，再也不用到处找资源了。热门漫画全集免费阅读，一次看过瘾，太爽了！',
    likes: 487,
    manga: '《一人之下》',
  },
];

export const topicsData = [
  { id: 1, name: '热血战斗', heat: '128.6万', color: 'bg-primary-100 text-primary-700' },
  { id: 2, name: '玄幻修真', heat: '115.3万', color: 'bg-accent-100 text-accent-800' },
  { id: 3, name: '恋爱甜宠', heat: '98.7万', color: 'bg-secondary-100 text-secondary-800' },
  { id: 4, name: '悬疑推理', heat: '87.2万', color: 'bg-primary-100 text-primary-700' },
  { id: 5, name: '搞笑日常', heat: '76.5万', color: 'bg-accent-100 text-accent-800' },
  { id: 6, name: '穿越重生', heat: '72.1万', color: 'bg-secondary-100 text-secondary-800' },
  { id: 7, name: '科幻未来', heat: '65.8万', color: 'bg-primary-100 text-primary-700' },
  { id: 8, name: '都市生活', heat: '58.4万', color: 'bg-accent-100 text-accent-800' },
  { id: 9, name: '古风仙侠', heat: '52.9万', color: 'bg-secondary-100 text-secondary-800' },
  { id: 10, name: '日漫精选', heat: '49.3万', color: 'bg-primary-100 text-primary-700' },
  { id: 11, name: '新番速递', heat: '46.7万', color: 'bg-accent-100 text-accent-800' },
];

export const carouselData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20martial%20arts%20manga%20illustration%20with%20dynamic%20battle%20scene%2C%20warm%20orange%20and%20gold%20energy%20effects%2C%20anime%20art%20style%2C%20dramatic%20composition%2C%20cinematic%20lighting%2C%20high%20quality%20digital%20painting%20with%20clean%20simple%20background&width=800&height=500&seq=carousel-manga-01&orientation=landscape',
    title: '斗破苍穹',
    tag: '年度热门',
    desc: '萧炎历经磨难重返巅峰，热血战斗引爆全网，千万读者追更中！',
    readers: '1,286万',
    chapters: '586话',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20with%20cherry%20blossom%20and%20couple%20under%20moonlight%2C%20soft%20warm%20amber%20tones%2C%20beautiful%20anime%20art%20style%2C%20dreamy%20atmosphere%2C%20high%20quality%20digital%20illustration&width=800&height=500&seq=carousel-manga-02&orientation=landscape',
    title: '甜心陷阱',
    tag: '恋爱精选',
    desc: '高冷总裁与元气少女的甜蜜碰撞，每一话都让人心跳加速，恋爱漫画必看！',
    readers: '958万',
    chapters: '320话',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20manga%20scene%20with%20noir%20atmosphere%2C%20warm%20candlelight%20and%20shadows%2C%20suspenseful%20anime%20art%20style%2C%20dramatic%20lighting%2C%20high%20quality%20digital%20painting&width=800&height=500&seq=carousel-manga-03&orientation=landscape',
    title: '迷雾之都',
    tag: '悬疑精品',
    desc: '一座被迷雾笼罩的城市，连环案件背后的惊天秘密，烧脑推理不容错过！',
    readers: '763万',
    chapters: '198话',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20cultivation%20manga%20scene%20with%20ancient%20Chinese%20architecture%20and%20floating%20islands%2C%20warm%20golden%20sunset%20lighting%2C%20epic%20anime%20art%20style%2C%20majestic%20composition%2C%20high%20quality%20digital%20illustration&width=800&height=500&seq=carousel-manga-04&orientation=landscape',
    title: '仙路尽头',
    tag: '玄幻力作',
    desc: '凡人修仙踏上逆天之路，宏大世界观构建，玄幻漫画天花板级作品！',
    readers: '1,102万',
    chapters: '452话',
  },
];

export const rankingData = [
  { id: 1, rank: 1, title: '斗破苍穹', heat: '1,286万', trend: 'up', change: '+2', tag: '热血' },
  { id: 2, rank: 2, title: '完美世界', heat: '1,158万', trend: 'up', change: '+1', tag: '玄幻' },
  { id: 3, rank: 3, title: '一人之下', heat: '1,032万', trend: 'down', change: '-1', tag: '国漫' },
  { id: 4, rank: 4, title: '仙路尽头', heat: '987万', trend: 'up', change: '+3', tag: '修仙' },
  { id: 5, rank: 5, title: '甜心陷阱', heat: '876万', trend: 'down', change: '-2', tag: '恋爱' },
  { id: 6, rank: 6, title: '迷雾之都', heat: '745万', trend: 'up', change: '+4', tag: '悬疑' },
  { id: 7, rank: 7, title: '全职高手', heat: '698万', trend: 'stable', change: '0', tag: '电竞' },
];

export const cardsData = [
  {
    id: 1,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20with%20martial%20arts%20hero%20holding%20flaming%20sword%2C%20warm%20orange%20and%20red%20color%20scheme%2C%20anime%20style%2C%20clean%20background%2C%20professional%20manga%20cover%20design&width=400&height=560&seq=card-manga-01&orientation=portrait',
    title: '斗破苍穹',
    tag: '热血·玄幻',
    desc: '萧炎，一个曾经的天才少年，在家族没落后不屈不挠，踏上修炼之路...',
    status: '连载中',
    update: '今日更新',
  },
  {
    id: 2,
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20cover%20with%20beautiful%20couple%20under%20sakura%20tree%2C%20soft%20pink%20and%20warm%20amber%20tones%2C%20anime%20art%20style%2C%20clean%20elegant%20design&width=400&height=560&seq=card-manga-02&orientation=portrait',
    title: '甜心陷阱',
    tag: '恋爱·都市',
    desc: '冷面总裁遇上元气少女，一场甜蜜又搞笑的爱情故事就此展开...',
    status: '连载中',
    update: '昨日更新',
  },
  {
    id: 3,
    cover: 'https://readdy.ai/api/search-image?query=Horror%20mystery%20manga%20cover%20with%20detective%20character%20in%20foggy%20city%2C%20warm%20brown%20and%20dark%20amber%20tones%2C%20anime%20art%20style%2C%20thriller%20atmosphere&width=400&height=560&seq=card-manga-03&orientation=portrait',
    title: '迷雾之都',
    tag: '悬疑·推理',
    desc: '迷雾笼罩的城市中，连环案件频发，天才侦探揭开惊天秘密...',
    status: '连载中',
    update: '3天前更新',
  },
  {
    id: 4,
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20cultivation%20manga%20cover%20with%20immortal%20cultivator%20on%20cloud%20mountain%2C%20warm%20golden%20and%20green%20tones%2C%20anime%20art%20style%2C%20epic%20atmosphere&width=400&height=560&seq=card-manga-04&orientation=portrait',
    title: '仙路尽头',
    tag: '玄幻·修仙',
    desc: '凡人少年偶得仙缘，从此踏上逆天修仙之路，万界称尊...',
    status: '连载中',
    update: '今日更新',
  },
  {
    id: 5,
    cover: 'https://readdy.ai/api/search-image?query=Comedy%20slice%20of%20life%20manga%20cover%20with%20funny%20high%20school%20characters%2C%20bright%20warm%20colors%2C%20anime%20art%20style%2C%20cheerful%20vibrant%20design&width=400&height=560&seq=card-manga-05&orientation=portrait',
    title: '校园爆笑王',
    tag: '搞笑·日常',
    desc: '一群奇葩学生的爆笑校园生活，每一话都能让你笑到肚子疼...',
    status: '连载中',
    update: '昨日更新',
  },
  {
    id: 6,
    cover: 'https://readdy.ai/api/search-image?query=Science%20fiction%20manga%20cover%20with%20futuristic%20mecha%20and%20space%20battle%2C%20warm%20orange%20and%20metallic%20tones%2C%20anime%20art%20style%2C%20epic%20sci-fi%20design&width=400&height=560&seq=card-manga-06&orientation=portrait',
    title: '星际战纪',
    tag: '科幻·机甲',
    desc: '人类文明进入星际时代，少年驾驶机甲保卫家园的热血故事...',
    status: '连载中',
    update: '5天前更新',
  },
  {
    id: 7,
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20manga%20cover%20with%20ancient%20warrior%20princess%2C%20warm%20golden%20and%20coral%20tones%2C%20anime%20art%20style%2C%20elegant%20classical%20design&width=400&height=560&seq=card-manga-07&orientation=portrait',
    title: '凤倾天下',
    tag: '古风·权谋',
    desc: '她本是现代特工，一朝穿越成废材嫡女，运筹帷幄搅动天下风云...',
    status: '已完结',
    update: '全集可读',
  },
];

export const indexData = [
  { id: 1, name: '热血战斗', icon: 'ri-sword-line', count: '2,368部', color: 'bg-primary-100 text-primary-700' },
  { id: 2, name: '玄幻修真', icon: 'ri-moon-clear-line', count: '1,956部', color: 'bg-accent-100 text-accent-800' },
  { id: 3, name: '恋爱甜宠', icon: 'ri-heart-line', count: '1,823部', color: 'bg-secondary-100 text-secondary-800' },
  { id: 4, name: '悬疑推理', icon: 'ri-search-eye-line', count: '1,247部', color: 'bg-primary-100 text-primary-700' },
  { id: 5, name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: '1,568部', color: 'bg-accent-100 text-accent-800' },
  { id: 6, name: '穿越重生', icon: 'ri-loop-left-line', count: '1,432部', color: 'bg-secondary-100 text-secondary-800' },
  { id: 7, name: '科幻未来', icon: 'ri-rocket-line', count: '986部', color: 'bg-primary-100 text-primary-700' },
  { id: 8, name: '古风仙侠', icon: 'ri-empathize-line', count: '1,675部', color: 'bg-accent-100 text-accent-800' },
];

export const faqData = [
  {
    id: 1,
    q: '汗汗漫画真的完全免费吗？',
    a: '是的！汗汗漫画始终坚持全集免费阅读的宗旨，所有漫画无需付费、无需会员即可畅读。我们通过广告合作维持运营，确保每一位漫迷都能无门槛享受漫画的乐趣。',
  },
  {
    id: 2,
    q: '漫画的更新速度怎么样？',
    a: '汗汗漫画拥有专业的更新团队，热门漫画基本与官方同步更新。大部分作品每日或每周固定更新，遇到节假日还会加更，让你追更追到停不下来。',
  },
  {
    id: 3,
    q: '支持哪些设备阅读漫画？',
    a: '汗汗漫画全面适配PC端、平板和手机端，无论在电脑前还是地铁上，都能获得流畅的阅读体验。手机端更有专属适配模式，翻页顺滑、加载迅速。',
  },
  {
    id: 4,
    q: '漫画资源包含哪些类型？',
    a: '平台涵盖热血战斗、玄幻修真、恋爱甜宠、悬疑推理、搞笑日常、穿越重生、科幻未来、古风仙侠等全品类漫画，日漫国漫应有尽有，海量资源任你挑选。',
  },
  {
    id: 5,
    q: '如何找到自己想看的漫画？',
    a: '首页提供分类索引、热门排行和标签筛选功能，也可以通过搜索框直接搜索漫画名称。热门话题区域帮你发现当下最火的漫画作品，轻松找到心仪内容。',
  },
  {
    id: 6,
    q: '可以收藏和追更喜欢的漫画吗？',
    a: '当然可以！汗汗漫画支持漫画收藏功能，收藏后可在个人书架随时查看。收藏的漫画有更新时会第一时间提醒，让你不错过任何精彩章节。',
  },
];

export const updatesData = [
  { id: 1, date: '2026-07-28', title: '《斗破苍穹》第586话更新', desc: '萧炎与魂族终极对决，炎帝之力全面觉醒！', tag: '热门更新' },
  { id: 2, date: '2026-07-28', title: '《甜心陷阱》第320话更新', desc: '总裁的秘密身份曝光，女主的反应让人心疼...', tag: '催泪' },
  { id: 3, date: '2026-07-27', title: '《仙路尽头》第452话更新', desc: '剑开天门！主角终于踏入传说中的上界！', tag: '高能' },
  { id: 4, date: '2026-07-27', title: '《迷雾之都》第198话更新', desc: '真凶浮出水面，一切的谜团终于有了答案...', tag: '解谜' },
  { id: 5, date: '2026-07-26', title: '《校园爆笑王》第235话更新', desc: '运动会特辑！全班同学各显神通的爆笑操作！', tag: '搞笑' },
  { id: 6, date: '2026-07-26', title: '《凤倾天下》全集更新完毕', desc: '最终章震撼收尾，女主登基称帝，天下归心！', tag: '完结' },
  { id: 7, date: '2026-07-25', title: '《星际战纪》第178话更新', desc: '新机体亮相！史上最强机甲震撼登场！', tag: '热血' },
];

export const mediaData = [
  {
    id: 1,
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20video%20thumbnail%20with%20manga%20reading%20tutorial%20scene%2C%20warm%20orange%20gradient%20overlay%2C%20play%20button%20center%2C%20clean%20professional%20design%2C%20YouTube%20thumbnail%20style&width=640&height=360&seq=media-thumb-01&orientation=landscape',
    title: '新手必看！漫画阅读指南',
    duration: '05:32',
    views: '32.6万',
  },
  {
    id: 2,
    thumbnail: 'https://readdy.ai/api/search-image?query=Manga%20recommendation%20video%20thumbnail%20with%20popular%20manga%20covers%20collage%2C%20warm%20amber%20accent%2C%20professional%20design%2C%20clean%20layout&width=640&height=360&seq=media-thumb-02&orientation=landscape',
    title: '本月必追漫画TOP10推荐',
    duration: '08:15',
    views: '56.8万',
  },
  {
    id: 3,
    thumbnail: 'https://readdy.ai/api/search-image?query=Manga%20character%20cosplay%20video%20thumbnail%2C%20warm%20coral%20tones%2C%20professional%20cosplay%20photography%2C%20anime%20style%2C%20clean%20design&width=640&height=360&seq=media-thumb-03&orientation=landscape',
    title: '人气角色cosplay大赏',
    duration: '12:47',
    views: '89.3万',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '安全无毒',
    desc: '全站内容经过严格审核，无弹窗无恶意广告，提供纯净安全的漫画阅读环境。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '采用先进CDN加速技术，漫画图片秒开加载，翻页丝滑流畅不卡顿。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: 'PC、平板、手机全终端完美适配，随时随地畅享漫画阅读乐趣。',
  },
  {
    id: 4,
    icon: 'ri-book-open-line',
    title: '海量资源',
    desc: '涵盖数万部热门漫画，日漫国漫一网打尽，新番老番全部免费阅读。',
  },
  {
    id: 5,
    icon: 'ri-timer-line',
    title: '实时追更',
    desc: '热门漫画与官方同步更新，设置追更提醒，精彩章节不再错过。',
  },
];

export const heroStats = [
  { label: '收录漫画', value: '35,000+' },
  { label: '日活读者', value: '280万+' },
  { label: '每日更新', value: '500+话' },
];